import React, { useEffect, useState } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import { Bar, Chart } from 'react-chartjs-2';
import { setCurrencyFormat } from '../../../../utils/helpers';

// const getRandomData = () => new Array(100).fill(0).map(() => `${Math.floor(Math.random() * 100)}`);
const colorArr = [
  '#5276ff',
  '#ffbca0',
  '#ff6d8c',
  '#b4ffa0',
  '#ffeba0',
  '#ffa0b4',
  '#a0ffeb',
  '#5c85ff',
  '#34ebb4',
  '#eb8034',
  '#34a8eb',
  '#bca0ff',
];

const colorData = (num, hover = false) => {
  let color = colorArr[num - 1];
  if (hover) {
    color = `${colorArr[num - 1]}`;
  }
  return color;
};

// ['January;2015', 'February;2015', 'March;2015', 'April;2015', 'May;2015', 'Jun;2015',
//   'July;2015', 'August;2015', 'September;2015', 'October;2015', 'November;2015', 'December;2015',
//   'January;2016', 'February;2016', 'March;2016', 'April;2016', 'May;2016', 'Jun;2016',
//   'July;2016', 'August;2016', 'September;2016', 'October;2016', 'November;2016', 'December;2016',
//   'January;2017', 'February;2017', 'March;2017', 'April;2017', 'May;2017', 'Jun;2017',
//   'July;2017', 'August;2017', 'September;2017', 'October;2017', 'November;2017', 'December;2017',
//   'January;2018', 'February;2018', 'March;2018', 'April;2018', 'May;2018', 'Jun;2018',
//   'July;2018', 'August;2018', 'September;2018', 'October;2018', 'November;2018', 'December;2018',
//   'January;2019', 'February;2019', 'March;2019', 'April;2019', 'May;2019', 'Jun;2019',
//   'July;2019', 'August;2019', 'September;2019', 'October;2019', 'November;2019', 'December;2019',
//   'January;2019', 'February;2020', 'March;2020', 'April;2020', 'May;2020', 'Jun;2020',
//   'July;2019', 'August;2020', 'September;2020', 'October;2020', 'November;2020', 'December;2020',
//   'January;2021', 'February;2021', 'March;2021', 'April;2021', 'May;2021', 'Jun;2021',
// ]

const addMonthlyAmount = (total, num) => (Number(total) + Number(num)).toFixed(2);
const reduceArray = (obj) => {
  if (obj && obj.length > 0) {
    return obj.reduce(addMonthlyAmount);
  }
  return 0;
};
const getYearData = (dataSet) => {
  const yearArray = [];
  if (dataSet && dataSet.length > 0) {
    dataSet.forEach((innerObj) => {
      if (!yearArray.includes(innerObj.salesYear)) {
        yearArray.push(innerObj.salesYear);
      }
    });
  }

  return yearArray;
};

const getDataSets = (dataSet) => {
  if (dataSet && dataSet.length > 0) {
    const yearArray = [];
    if (dataSet && dataSet.length > 0) {
      dataSet.forEach((innerObj) => {
        if (!yearArray.includes(innerObj.salesYear)) {
          yearArray.push(innerObj.salesYear);
        }
      });
    }
    const jan = dataSet.filter(x => x.salesMonth === '1');
    const feb = dataSet.filter(x => x.salesMonth === '2');
    const mar = dataSet.filter(x => x.salesMonth === '3');
    const apr = dataSet.filter(x => x.salesMonth === '4');
    const may = dataSet.filter(x => x.salesMonth === '5');
    const jun = dataSet.filter(x => x.salesMonth === '6');
    const jul = dataSet.filter(x => x.salesMonth === '7');
    const aug = dataSet.filter(x => x.salesMonth === '8');
    const sep = dataSet.filter(x => x.salesMonth === '9');
    const oct = dataSet.filter(x => x.salesMonth === '8');
    const nov = dataSet.filter(x => x.salesMonth === '11');
    const dec = dataSet.filter(x => x.salesMonth === '12');
    const set1 = [];
    const set2 = [];
    const set3 = [];
    const set4 = [];
    const set5 = [];
    const set6 = [];
    const set7 = [];
    const set8 = [];
    const set9 = [];
    const set10 = [];
    const set11 = [];
    const set12 = [];

    yearArray.forEach((ele) => {
      set1
        .push(
          reduceArray(jan.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set2
        .push(
          reduceArray(feb.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set3
        .push(
          reduceArray(mar.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set4
        .push(
          reduceArray(apr.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set5
        .push(
          reduceArray(may.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set6
        .push(
          reduceArray(jun.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set7
        .push(
          reduceArray(jul.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set8
        .push(
          reduceArray(aug.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set9
        .push(
          reduceArray(sep.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set10
        .push(
          reduceArray(oct.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set11
        .push(
          reduceArray(nov.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
      set12
        .push(
          reduceArray(dec.filter(x => x.salesYear === ele).map(data => Number(data.amount))),
        )
        .toFixed(2);
    });

    return [
      {
        key: 1,
        label: 'Jan',
        borderColor: colorData(1),
        borderWidth: 0,
        hoverBackgroundColor: colorData(1, true),
        hoverBorderColor: colorData(1, true),
        data: set1,
        backgroundColor: colorData(1),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 2,
        label: 'Feb',
        borderColor: colorData(2),
        borderWidth: 0,
        hoverBackgroundColor: colorData(2, true),
        hoverBorderColor: colorData(2, true),
        data: set2,
        backgroundColor: colorData(2),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 3,
        label: 'Mar',
        borderColor: colorData(3),
        borderWidth: 0,
        hoverBackgroundColor: colorData(3, true),
        hoverBorderColor: colorData(3, true),
        data: set3,
        backgroundColor: colorData(3),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 4,
        label: 'Apr',
        borderColor: colorData(4),
        borderWidth: 0,
        hoverBackgroundColor: colorData(4, true),
        hoverBorderColor: colorData(4, true),
        data: set4,
        backgroundColor: colorData(4),
        tooltip: value => `${setCurrencyFormat(value, true)}`,
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 5,
        label: 'May',
        borderColor: colorData(5),
        borderWidth: 0,
        hoverBackgroundColor: colorData(5, true),
        hoverBorderColor: colorData(5, true),
        data: set5,
        backgroundColor: colorData(5),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 6,
        label: 'Jun',
        borderColor: colorData(6),
        borderWidth: 0,
        hoverBackgroundColor: colorData(6, true),
        hoverBorderColor: colorData(6, true),
        data: set6,
        backgroundColor: colorData(6),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 7,
        label: 'Jul',
        borderColor: colorData(7),
        borderWidth: 0,
        hoverBackgroundColor: colorData(7, true),
        hoverBorderColor: colorData(7, true),
        data: set7,
        backgroundColor: colorData(7),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 8,
        label: 'Aug',
        borderColor: colorData(8),
        borderWidth: 0,
        hoverBackgroundColor: colorData(8, true),
        hoverBorderColor: colorData(8, true),
        data: set8,
        backgroundColor: colorData(8),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 9,
        label: 'Sep',
        borderColor: colorData(9),
        borderWidth: 0,
        hoverBackgroundColor: colorData(9, true),
        hoverBorderColor: colorData(9, true),
        data: set9,
        backgroundColor: colorData(9),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 10,
        label: 'Oct',
        borderColor: colorData(10),
        borderWidth: 0,
        hoverBackgroundColor: colorData(10),
        hoverBorderColor: colorData(10),
        data: set10,
        backgroundColor: colorData(10),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 11,
        label: 'Nov',
        borderColor: colorData(11),
        borderWidth: 0,
        hoverBackgroundColor: colorData(11),
        hoverBorderColor: colorData(11),
        data: set11,
        backgroundColor: colorData(11),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
      {
        key: 12,
        label: 'Dec',
        borderColor: colorData(12),
        borderWidth: 0,
        hoverBackgroundColor: colorData(12),
        hoverBorderColor: colorData(12),
        data: set12,
        backgroundColor: colorData(12),
        datalabels: {
          align: 'end',
          anchor: 'end',
          rotation: 270,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value, true)}`,
        },
      },
    ];
  }
  return [];
};

const getState = data => ({
  labels: getYearData(data),
  datasets: getDataSets(data),
});

const options = {
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        let label = data.datasets[tooltipItem.datasetIndex].label || '';

        if (label) {
          label += ': ';
        }

        // eslint-disable-next-line max-len
        label += setCurrencyFormat(tooltipItem.yLabel.toFixed(2), true); // Math.round(tooltipItem.yLabel * 100) / 100;
        return label;
      },
    },
  },
  datalabels: {
    display: true,
    color: '#000',
  },
  legend: {
    display: false,
  },

  // Core options
  layout: {
    padding: {
      top: 24,
      right: 0,
      bottom: 0,
      left: 8,
    },
  },
  elements: {
    line: {
      fill: false,
    },
    point: {
      hoverRadius: 7,
      radius: 5,
    },
  },
  scales: {
    xAxes: [
      {
        stacked: false,
      },
    ],
    yAxes: [
      {
        stacked: false,
      },
    ],
  },
};

const RandomAnimatedBars = (props) => {
  const { title, revenueData, setModel } = props;
  const { t } = useTranslation('common');
  const [data, setData] = useState(getState());
  const [currentYearTotalAmount, setCurrentYearTotalAmount] = useState(0);
  const [previousYearTotalAmount, setPreviousYearTotalAmount] = useState(0);

  Chart.plugins.register(ChartDataLabels);
  useEffect(() => {
    setData(revenueData ? getState(revenueData) : []);
    if (revenueData && revenueData.length > 0) {
      setCurrentYearTotalAmount(
        revenueData
          .filter(
            item =>
              Number(item.salesYear) === new Date().getFullYear() &&
              Number(item.salesMonth) === new Date().getMonth() + 1,
          )
          .map(item => item.amount)
          .reduce((a, b) => Number(a) + Number(b), 0)
          .toFixed(2),
      );
      setPreviousYearTotalAmount(
        revenueData
          .filter(
            item =>
              Number(item.salesYear) === new Date().getFullYear() - 1 &&
              Number(item.salesMonth) === new Date().getMonth(),
          )
          .map(item => item.amount)
          .reduce((a, b) => Number(a) + Number(b), 0)
          .toFixed(2),
      );
    }
  }, [revenueData]);
  const totalAmount = reduceArray(revenueData.map(x => x.amount));
  const totalAmounts = (totalAmount / 1000000).toFixed(2);

  const getPercentage = (currValue, preValue) =>
    (((currValue - preValue) / preValue) * 100).toFixed(2) || '0.00';

  return (
    <Col md={12} lg={12} xl={12}>
      <Card>
        <CardBody className="dashboard__card-widget card-shadow">
          <div className="card__title">
            <h5 className="bold-text">{t(title)}</h5>
            <button
              type="button"
              className="view-report btn btn-primary btn-sm"
              onClick={() => setModel(true)}
            >
              View Report
            </button>
          </div>
          <div className="second-header-for-chart">
            <div className="left">
              <h5 className="bold-text colored">$ {totalAmounts} Million</h5>
              <h5 className="bold-text">{t('Total Amount')}</h5>
            </div>
            <div className="right">
              {getPercentage(currentYearTotalAmount, previousYearTotalAmount) < 0 && (
                <h5 className="bold-text colored">
                  <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,6L9.41,12L13.41,8L19.71,
                        14.29L22,12V18H16Z"
                    />
                  </svg>
                  {getPercentage(currentYearTotalAmount, previousYearTotalAmount)}%
                </h5>
              )}
              {getPercentage(currentYearTotalAmount, previousYearTotalAmount) > 0 && (
                <h5 className="bold-text colored">
                  <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,
                        12L13.41,16L19.71,9.71L22,12V6H16Z"
                    />
                  </svg>
                  {getPercentage(currentYearTotalAmount, previousYearTotalAmount)}%
                </h5>
              )}
              <h5 className="bold-text">{t('Since last month')}</h5>
            </div>
          </div>
          <div style={{ marginTop: '120px' }}>
            <Bar data={data} options={options} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
RandomAnimatedBars.propTypes = {
  title: PropTypes.string.isRequired,
  revenueData: PropTypes.string.isRequired,
  setModel: PropTypes.func.isRequired,
};

export default RandomAnimatedBars;
